// extracted by mini-css-extract-plugin
export default {"wrapper":"x7-z"};